import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';

import {MatSnackBar} from '@angular/material';

import {ContentSize} from '../../modules/shared/components/page/page.component';

import {AuthService} from '../../services/auth.service';
import {LogService} from '../../services/log.service';
import {OauthService} from '../../services/oauth.service';
import {PerfService} from '../../services/perf.service';

import {DialogComponent} from '../../modules/shared/components/dialog/dialog.component';

import * as uuid from 'uuid';


@Component({
	selector: 'oauth-callback',
	templateUrl: './oauth-callback.component.html',
	styleUrls: ['./oauth-callback.component.scss']
})
export class OauthCallbackComponent implements OnInit, AfterViewInit {
	constructor(
		private location: Location,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private sanitizer: DomSanitizer,
		private snackBar: MatSnackBar,

		private authService: AuthService,
		private log: LogService,
		private oauthService: OauthService,
		private perf: PerfService
	) {}


	ContentSize = ContentSize;		// enable enum in template

	// viewHeight = '';

	// dialogTitle = '';
	// dialogContent1 = '';
	// dialogContent2 = '';
	// dialogOk = '';
	// dialogCancel = '';
	// dialogData = '';
	// helpUrlLabel = '';
	// helpUrlString = '';
	// @ViewChild('confirmDialog') confirmDialog: DialogComponent;

	oauthAuthorizeCode = '';
	oauthError = '';
	oauthState = '';
	emailProvider = '';
	errorDescription = '';


	ngOnInit() {
		console.log('OauthCallbackComponent ngOnInit');
		window.scrollTo(0, 0);

		// this.activatedRoute.queryParams
		this.activatedRoute.params
			// .filter(params => params.order)
			.subscribe(params => {
				console.log('params');
				console.log(params);

				if (params.code) {
					this.oauthAuthorizeCode = params.code;
				}
				if (params.error) {
					this.oauthError = params.error;
				}
				if (params.error_description) {
					this.errorDescription = params.error_description;
				}
				if (params.state) {
					this.oauthState = params.state;
				}
				console.log('this.oauthAuthorizeCode');
				console.log(this.oauthAuthorizeCode);
				console.log('this.oauthError');
				console.log(this.oauthError);
				console.log('this.errorDescription');
				console.log(this.errorDescription);
				console.log('this.oauthState');
				console.log(this.oauthState);

				if (this.oauthState) {
					if (this.oauthState.indexOf('gmail') === 0) {
						this.emailProvider = 'gmail';
					} else if (this.oauthState.indexOf('outlook') === 0) {
						this.emailProvider = 'outlook';
					}
				}
				console.log('this.emailProvider');
				console.log(this.emailProvider);

				if (this.oauthError) {
					return;
				}

				let payload: any = {
					oauthAuthorizeCode: this.oauthAuthorizeCode,
					organizationId: this.authService.organizationId,
					emailProvider: this.emailProvider
				};
				console.log('payload');
				console.log(payload);

				this.oauthService.createEmailAccessToken(payload)
				.then((result: any) => {
					console.log('OauthCallbackComponent, result');
					console.log(result);
					this.log.info('createEmailAccessToken successful');
					this.router.navigate(['/organization/settings/authorizedemail']);
					return;
				})
				.catch((err: any) => {
					console.log(err);
					this.log.error(err);

					this.oauthAuthorizeCode = '';
					this.oauthError = '';
					this.oauthState = '';
					this.emailProvider = '';
					this.snackBar.open('Could not create email access token.', 'X', {duration: 2000});
				});
		});
	}


	ngAfterViewInit() {
		this.perf.markTabLoadEnd('landing');
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/oauth-callback/oauth-callback.component.ts